<template>
  <section class="section">
    <div class="container">
      <div class="section-title">
        <h2>硬件电路IP库商城</h2>
        <p>连接全球设计师与工程师，加速创新与协作</p>
      </div>

      <!-- 重新设计的入口 -->
      <div class="marketplace-entrance">
        <div class="entrance-card">
          <div class="entrance-icon">
            <i class="fas fa-boxes" />
          </div>
          <h3>设计资源库</h3>
          <p>探索经过验证的设计资源，加速您的项目开发。从成熟解决方案到创新设计模式，获取高质量、可复用的设计资产。</p>
          <button
            class="btn"
            onclick="exploreResources()"
          >
            <i class="fas fa-search" /> 探索资源
          </button>
        </div>

        <div class="entrance-card">
          <div class="entrance-icon">
            <i class="fas fa-share-alt" />
          </div>
          <h3>发布设计</h3>
          <p>分享您的专业设计，与全球社区共同成长。将您的创意转化为可复用资产，获得认可并获得收益。</p>
          <button
            class="btn"
            onclick="contributeDesign()"
          >
            <i class="fas fa-upload" /> 开始发布
          </button>
        </div>
      </div>

      <!-- 平台能力展示 -->
      <div class="platform-capabilities">
        <div class="capability">
          <div class="capability-icon">
            <i class="fas fa-check-circle" />
          </div>
          <div class="capability-title">
            质量验证
          </div>
        </div>
        <div class="capability">
          <div class="capability-icon">
            <i class="fas fa-bolt" />
          </div>
          <div class="capability-title">
            性能优化
          </div>
        </div>
        <div class="capability">
          <div class="capability-icon">
            <i class="fas fa-users" />
          </div>
          <div class="capability-title">
            社区驱动
          </div>
        </div>
        <div class="capability">
          <div class="capability-icon">
            <i class="fas fa-lock" />
          </div>
          <div class="capability-title">
            安全可靠
          </div>
        </div>
        <div class="capability">
          <div class="capability-icon">
            <i class="fas fa-rocket" />
          </div>
          <div class="capability-title">
            快速集成
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
    function exploreResources() {
      alert("跳转到设计资源探索页面");
    }
    
    function contributeDesign() {
      alert("跳转到设计发布页面");
    }
</script>

 <style scoped>
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
    }

    .section {
      padding: 80px 0;
    }

    .section-title {
      text-align: center;
      margin-bottom: 60px;
    }

    .section-title h2 {
      font-size: 2.5rem;
      margin-bottom: 20px;
      color: var(--secondary);
      background: linear-gradient(90deg, var(--gray-500), var(--gray-700));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .section-title p {
      font-size: 1.2rem;
      color: var(--gray);
      max-width: 700px;
      margin: 0 auto;
    }

    /* 优化入口设计 */
    .marketplace-entrance {
      display: flex;
      justify-content: center;
      gap: 30px;
      margin-top: 40px;
      background: var(--gray-50);
    }

    .entrance-card {
      width: 380px;
      border: 1px solid var(--gray-200);
      border-radius: 20px;
      padding: 35px 30px;
      text-align: center;
      box-shadow: var(--card-shadow);
      transition: var(--transition);
      border: 1px solid rgba(139, 92, 246, 0.1);
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .entrance-card:hover {
      transform: translateY(-8px);
      box-shadow: var(--card-shadow-hover);
    }

    .entrance-card::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 6px;
      background: linear-gradient(to right, var(--gray-500), var(--gray-700));
    }

    .entrance-icon {
      width: 80px;
      height: 80px;
      background: var(--accent-100);;
      border-radius: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 25px;
      color: var(--accent-500);
      font-size: 32px;
      transition: var(--transition);
    }

    .entrance-card:hover .entrance-icon {
      background: linear-gradient(135deg, var(--gray-500), var(--gray-700));
      color: white;
      transform: scale(1.05);
    }

    .entrance-card h3 {
      font-size: 1.7rem;
      margin-bottom: 16px;
      color: var(--secondary);
      position: relative;
      padding-bottom: 12px;
    }

    .entrance-card h3::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 4px;
      background: var(--gradient-accent);
      border-radius: 3px;
    }

    .entrance-card p {
      color: var(--gray);
      margin-bottom: 28px;
      font-size: 1.05rem;
      line-height: 1.7;
    }

    .entrance-card .btn {
      padding: 14px 32px;
      font-size: 1.1rem;
      border-radius: 12px;
      font-weight: 600;
      background: var(--gray-600);
      color: white;
      border: none;
      cursor: pointer;
      transition: var(--transition);
      box-shadow: 0 5px 15px rgba(37, 99, 235, 0.3);
      display: inline-flex;
      align-items: center;
      gap: 10px;
    }

    .entrance-card .btn:hover {
      background: var(--primary-dark);
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(37, 99, 235, 0.4);
    }

    /* 平台能力展示 */
    .platform-capabilities {
      display: flex;
      justify-content: center;
      gap: 25px;
      margin-top: 50px;
      flex-wrap: wrap;
    }

    .capability {
      background: rgba(255, 255, 255, 0.7);
      backdrop-filter: blur(10px);
      padding: 20px;
      border-radius: 16px;
      width: 180px;
      text-align: center;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.5);
    }

    .capability-icon {
      font-size: 28px;
      color: var(--accent-500);
      margin-bottom: 12px;
    }

    .capability-title {
      font-weight: 600;
      color: var(--accent-500);
      font-size: 0.95rem;
    }

    /* 响应式调整 */
    @media (max-width: 992px) {
      .marketplace-entrance {
        flex-direction: column;
        align-items: center;
      }
      
      .entrance-card {
        width: 100%;
        max-width: 500px;
      }
    }

    @media (max-width: 768px) {
      .section {
        padding: 60px 0;
      }
      
      .section-title h2 {
        font-size: 2rem;
      }
      
      .platform-capabilities {
        gap: 15px;
      }
      
      .capability {
        width: 160px;
        padding: 15px;
      }
    }

    @media (max-width: 576px) {
      .entrance-card {
        padding: 25px 20px;
      }
      
      .entrance-icon {
        width: 70px;
        height: 70px;
        font-size: 28px;
      }
      
      .entrance-card h3 {
        font-size: 1.5rem;
      }
      
      .platform-capabilities {
        gap: 10px;
      }
      
      .capability {
        width: 140px;
      }
    }
  </style>
